import { render, staticRenderFns } from "./Renewal_Submitted.vue?vue&type=template&id=2ec20136&scoped=true&"
import script from "./Renewal_Submitted.vue?vue&type=script&lang=js&"
export * from "./Renewal_Submitted.vue?vue&type=script&lang=js&"
import style0 from "./Renewal_Submitted.vue?vue&type=style&index=0&id=2ec20136&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec20136",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
